module.exports = __webpack_public_path__ + "img/car-clr.2fb2ee9e.png";